import * as Validation from "../../../common/utils/Validation";
import {addEditDPSourceActionTypes} from "../../../veritas/add-edit/constants/AddEditActionConstants";
import {checkUpdateTimeActionTypes} from "../constants/UtilityMiddlewareConstants";
import {apiActionsDPSource} from "../constants/ApiMiddlewareConstants";

/**
 * This is the Middleware to validate the object generated by the add/edit DP Source
 * modal.
 * @param store, action
 * @returns Makes the call to custom validation procedure and conditionally dispatches
 * the check-update action or the post action
 */
const validateDPSourcesFormMiddleware = (store) => (next) => (action) => {
    switch (action.type) {

        case addEditDPSourceActionTypes.VALIDATE_DP_SOURCE_FORM: {
            next(action);

            const { sourceObject, resourceType, toDelete, authToken } = action.payload;

            if (Validation.validateSourceForm(sourceObject)) {
                if (sourceObject.source_detail.source_id) {
                    // check update
                    const sourceID = sourceObject.source_detail.source_id;
                    store.dispatch({
                        type: checkUpdateTimeActionTypes.DP_SOURCE,
                        payload: {sourceID, sourceObject, resourceType, toDelete, authToken},
                    })
                } else {
                    // post
                    if (resourceType === "kyc") {
                        store.dispatch({
                            type: apiActionsDPSource.POST,
                            payload: {sourceObject, authToken},
                        });
                    } else {
                        store.dispatch({
                            type: apiActionsDPSource.POST_KYB,
                            payload: {sourceObject, authToken},
                        });
                    }
                }
            }

            break;
        }

        default: next(action);
    }
}

export default validateDPSourcesFormMiddleware;
